import React from "react";
import { MessageSquarePlus, Search, Library, X } from "lucide-react";

const ChatSidebar = ({
  isMobile,
  sidebarOpen,
  collapsedSidebar,
  onToggleSidebar,
  onClose,
}) => {
  const items = [
    { icon: MessageSquarePlus, label: "چت جدید", onClick: () => {} },
    { icon: Search, label: "جستجوی چت", onClick: () => {} },
    { icon: Library, label: "کتابخانه", onClick: () => {} },
  ];

  const widthClass = collapsedSidebar && !isMobile ? "w-16" : "w-72";
  const translateClass = isMobile
    ? sidebarOpen
      ? "translate-x-0"
      : "translate-x-full"
    : "translate-x-0";

  return (
    <aside
      className={[
        "fixed top-0 bottom-0 right-0 z-40",
        widthClass,
        translateClass,
        "bg-white/85 dark:bg-slate-950/70 backdrop-blur",
        "border-l border-slate-200 dark:border-slate-800",
        "transition-transform duration-300 ease-out",
      ].join(" ")}
    >
      <div className="h-16 px-3 flex items-center justify-between border-b border-slate-200 dark:border-slate-800">
        <div className="text-right">
          {!collapsedSidebar || isMobile ? (
            <>
              <div className="text-sm font-extrabold text-slate-900 dark:text-white">
                پنل چت
              </div>
              <div className="text-[11px] text-slate-500 dark:text-slate-400">
                ابزارها و تاریخچه
              </div>
            </>
          ) : (
            <div className="w-10 h-10 rounded-2xl bg-slate-100 dark:bg-slate-900" />
          )}
        </div>

        <button
          type="button"
          onClick={isMobile ? onClose : onToggleSidebar}
          className="inline-flex items-center justify-center w-10 h-10 rounded-2xl hover:bg-slate-100 dark:hover:bg-slate-900 transition"
          aria-label="بستن"
        >
          {isMobile ? (
            <X className="w-5 h-5 text-slate-700 dark:text-slate-200" />
          ) : (
            <span className="text-xs text-slate-500 dark:text-slate-400">
              {collapsedSidebar ? "»" : "«"}
            </span>
          )}
        </button>
      </div>

      <nav className="p-3 space-y-2">
        {items.map((it) => (
          <button
            key={it.label}
            onClick={it.onClick}
            className={[
              "w-full inline-flex items-center gap-3 rounded-2xl px-3 py-2.5",
              "hover:bg-slate-100 dark:hover:bg-slate-900 transition",
              "text-slate-700 dark:text-slate-200 text-sm",
              collapsedSidebar && !isMobile
                ? "justify-center"
                : "justify-start",
            ].join(" ")}
          >
            <it.icon className="w-5 h-5 text-slate-600 dark:text-slate-300" />
            {(!collapsedSidebar || isMobile) && <span>{it.label}</span>}
          </button>
        ))}
      </nav>

      <div className="mt-auto p-3 border-t border-slate-200 dark:border-slate-800">
        <div
          className={[
            "rounded-2xl px-3 py-2 text-xs",
            "bg-slate-50 dark:bg-slate-900/50",
            "text-slate-600 dark:text-slate-300",
          ].join(" ")}
        >
          {collapsedSidebar && !isMobile ? "AI" : "Ozhan AI — نسخه داخلی"}
        </div>
      </div>
    </aside>
  );
};

export default ChatSidebar;
